import actionCreator from 'utils/actionCreator';

export const actions = actionCreator('app', [
  'SHOW_SNACKBAR',
  'HIDE_SNACKBAR',
  'UPDATE_SEARCH_PARAMS',
  'TOGGLE_APP_LOADING',
  'TOGGLE_DEMO_MODAL',
  'TOGGLE_PROVIDE_FEEDBACK_MODAL',
  'TOGGLE_SUBMIT_FEEDBACK',
  'CONTACT_UPDATE',
  'CHROME_EXTENSION_ACTIVE',
  'INSPECT_CHANGES_COUNT',
  'INSPECT_EXIT_CALLBACK',
  'TOGGLE_VIDEO_MODAL',
  'TOGGLE_TRELLO_GUIDE',
  'TOGGLE_ASANA_GUIDE',
  'TOGGLE_MULTIPLE_PAGES_MODAL',
  'TOGGLE_KEYBOARD_SHORTCUTS',
]);

export function showSnackbar(payload) {
  return {
    type: actions.SHOW_SNACKBAR,
    payload,
  };
}

export function hideSnackbar() {
  return {
    type: actions.HIDE_SNACKBAR,
  };
}

export function updateSearchParams(payload) {
  return {
    type: actions.UPDATE_SEARCH_PARAMS,
    payload,
  };
}

export function toggleAppLoading(payload) {
  return {
    type: actions.TOGGLE_APP_LOADING,
    payload,
  };
}

export function toggleDemoModal(payload) {
  return {
    type: actions.TOGGLE_DEMO_MODAL,
    payload,
  };
}

export function toggleProvideFeedbackModal(payload) {
  return {
    type: actions.TOGGLE_PROVIDE_FEEDBACK_MODAL,
    payload,
  };
}

export function toggleSubmitFeedback(payload) {
  return {
    type: actions.TOGGLE_SUBMIT_FEEDBACK,
    payload,
  };
}

export function contactUpdate(payload) {
  return {
    type: actions.CONTACT_UPDATE,
    payload,
  };
}

export function chromeExtensionActive(payload) {
  return {
    type: actions.CHROME_EXTENSION_ACTIVE,
    payload,
  };
}

export function inspectedChangesCount(payload) {
  return {
    type: actions.INSPECT_CHANGES_COUNT,
    payload,
  };
}

export function inspectExitCallback(payload) {
  return {
    type: actions.INSPECT_EXIT_CALLBACK,
    payload,
  };
}

export function toggleVideoModal(payload) {
  return {
    type: actions.TOGGLE_VIDEO_MODAL,
    payload,
  };
}

export function toggleTrelloGuide(payload) {
  return {
    type: actions.TOGGLE_TRELLO_GUIDE,
    payload,
  };
}

export function toggleAsanaGuide(payload) {
  return {
    type: actions.TOGGLE_ASANA_GUIDE,
    payload,
  };
}

export function toggleSimilarPagesModal(payload) {
  return {
    type: actions.TOGGLE_MULTIPLE_PAGES_MODAL,
    payload,
  };
}

export function toggleKeyboardShortcuts(payload) {
  return {
    type: actions.TOGGLE_KEYBOARD_SHORTCUTS,
    payload,
  };
}
